/**
 * Edition notes are written by the backend in English. The known formats are
 * shown in German; anything unrecognised is shown as written, never dropped.
 */
const SECTION: Record<string, string> = { news: 'Nachrichten', crossfit: 'CrossFit', events: 'Veranstaltungen' };
const sec = (s: string) => SECTION[s] ?? s;

const RULES: Array<[RegExp, (...m: string[]) => string]> = [
  [/^Local inference was not available while this edition was prepared\.$/, () => 'Die lokale Inferenz war bei der Erstellung dieser Ausgabe nicht verfügbar.'],
  [/^No eligible content for the (\S+) section\.$/, (s) => `Für ${sec(s)} gab es keine passenden Inhalte.`],
  [/^Source (\S+) has never been collected\.$/, (s) => `Die Quelle ${s} wurde noch nie abgerufen.`],
  [/^Source (\S+) last finished with status (\S+)\.$/, (s, st) => `Der letzte Abruf von ${s} endete mit Status „${st}“.`],
  [/^(\d+) of (\d+) (\S+) cards were generated without inference and show source text instead of a summary\.$/, (a, b, s) => `${a} von ${b} ${sec(s)}-Karten entstanden ohne Sprachmodell und zeigen Quellentext statt einer Zusammenfassung.`],
  [/^(\d+) of (\d+) (\S+) cards were generated without inference\.$/, (a, b, s) => `${a} von ${b} ${sec(s)}-Karten entstanden ohne Sprachmodell.`],
  [/^(\d+) of (\d+) (\S+) cards rest on source excerpts only; those publishers do not serve the full article\.$/, (a, b, s) => `${a} von ${b} ${sec(s)}-Karten beruhen nur auf dem Anriss der Quelle; diese Verlage liefern den ganzen Artikel nicht aus.`],
  [/^Source (.+) provided (\d+) of (\d+) (\S+) cards; the other sources contributed little\.$/, (src, a, b, s) => `${src} lieferte ${a} von ${b} ${sec(s)}-Karten; die anderen Quellen trugen wenig bei.`],
  [/^The newest (\S+) card is (.+) old; the sources for this section may not have been collected recently\.$/, (s, age) => `Die neueste ${sec(s)}-Karte ist ${age} alt; die Quellen wurden womöglich länger nicht abgerufen.`],
];

export function reasonText(r: string): string {
  for (const [re, f] of RULES) {
    const m = re.exec(r.trim());
    if (m) return f(...m.slice(1));
  }
  return r;
}
